import React from 'react'
import { IonItem, IonLabel } from '@ionic/react'
import { IValidationMessage } from '../../features/validation/store/validation.types'
import './Validation.component.css'

const ValidationMessage: React.FC<IValidationMessage> = (props: IValidationMessage) => {
  const { id, message } = props

  return (
    <div className='validation-wrapper'>
      <IonItem data-testid={id} lines='none' className='ion-no-margin validation'>
        <IonLabel color='danger' className='ion-text-wrap ion-no-margin ion-no-padding validation-text'>
          {message}
        </IonLabel>
      </IonItem>
    </div>
  )
}

export default ValidationMessage
